const TopBanner: React.FC = () => {
  return (
    <div className="bg-primary h-14 flex justify-center items-center text-white">
      <p>Al is the most innovative and disruptive technology on the market</p>
    </div>
  );
};

export default TopBanner;
